module.exports = __webpack_public_path__ + "static/media/birds_lake.8f7a213b.jpg";